module.exports = __webpack_public_path__ + "img/franchising_dynamics_city1.2c8185bc.png";